import styled from "styled-components";

export const Container = styled.div`
  position: absolute;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  z-index: 10;
`;
